<template>
  <div :id="rootId || undefined" class="wrapper msc-app-page" :class="pageClass">
    <header
      class="msc-app-page__header"
      :class="{ 'non-printable': !printable }"
    >
      <parallax
        class="msc-app-page__header-image"
        :style="{ backgroundImage: `url('${backgroundImage}')` }"
      />
      <div class="msc-app-page__header-scrim" aria-hidden="true" />
      <notifications
        v-if="showNotifications"
        :class="{ 'non-printable': !printable }"
      />
    </header>

    <main class="msc-app-page__body" :class="bodyClass">
      <div
        class="container msc-app-page__container"
        :class="{ 'msc-app-page__container--wide': wide }"
      >
        <slot />
      </div>
    </main>
  </div>
</template>

<script>
  import { Parallax } from '@/components';

  export const APP_PAGE_HEADER_IMAGE = '/img/back-to-school-start-MACVKugZ8WQ.jpg';

  export default {
    name: 'app-page-layout',
    components: {
      Parallax,
    },
    props: {
      rootId: {
        type: String,
        default: '',
      },
      pageClass: {
        type: [String, Array, Object],
        default: '',
      },
      bodyClass: {
        type: [String, Array, Object],
        default: '',
      },
      backgroundImage: {
        type: String,
        default: APP_PAGE_HEADER_IMAGE,
      },
      showNotifications: {
        type: Boolean,
        default: true,
      },
      printable: {
        type: Boolean,
        default: false,
      },
      wide: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
